import React, { useState } from 'react';
import PitruLeadAdmin from '../PitruLeadAdmin';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import ProviderApproval from '../ProviderApproval';
import './AdminDashboard.css';

const AdminDashboard: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('provider-approval');

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'pitru-v2':
        return <PitruLeadAdmin />;
      case 'provider-approval':
        return <ProviderApproval />;
      case 'dashboard':
        return (
          <div className="admin-overview">
            <h2>Dashboard Overview</h2>
            <p>Welcome to the admin dashboard. Use the navigation tabs to manage different aspects of the system.</p>
          </div>
        );
      default:
        return <ProviderApproval />;
    }
  };

  return (
    <div className="admin-dashboard">
      <header className="admin-header">
        <div className="admin-header-left">
          <h1>Admin Dashboard</h1>
          <span className="admin-welcome">Welcome, {user?.firstName} {user?.lastName}</span>
        </div>
        {/* <div className="admin-header-right">
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div> */}
      </header>

      <nav className="admin-nav">
        <div className="admin-nav-tabs">
          <button className={`nav-tab ${activeTab === 'pitru-v2' ? 'active' : ''}`} onClick={() => setActiveTab('pitru-v2')}>Pitru V2 leads</button>
          <button
            className={`nav-tab ${activeTab === 'dashboard' ? 'active' : ''}`}
            onClick={() => setActiveTab('dashboard')}
          >
            📊 Dashboard
          </button>
          <button
            className={`nav-tab ${activeTab === 'provider-approval' ? 'active' : ''}`}
            onClick={() => setActiveTab('provider-approval')}
          >
            👥 Provider Approvals
          </button>
        </div>
      </nav>

      <main className="admin-content">
        {renderTabContent()}
      </main>
    </div>
  );
};

export default AdminDashboard;
